import React, { useState } from 'react';

export const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    phone: '',
    email: '',
    service: '',
    workers: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://wlfaqwobsiosivinjivc.supabase.co/functions/v1/send-contact-email', {
        method: 'POST',
        body: formDataToSend,
      });

      const result = await response.json();

      if (result.success) {
        setSubmitMessage('感謝您的諮詢！我們會盡快與您聯繫。');
        setFormData({
          name: '',
          company: '',
          phone: '',
          email: '',
          service: '',
          workers: '',
          message: ''
        });
      } else {
        setSubmitMessage('提交失敗，請稍後再試或直接聯繫我們。');
      }
    } catch (error) {
      console.error('提交錯誤:', error);
      setSubmitMessage('提交失敗，請稍後再試或直接聯繫我們。');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">聯絡我們</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            立即聯繫我們的專業團隊，獲得最適合您企業需求的外勞招聘解決方案
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* 聯絡資訊 */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-800 mb-6">聯絡資訊</h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                    <i className="ri-phone-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">電話</p>
                    <p className="text-gray-600">+852 9366 3961</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                    <i className="ri-mail-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">電郵</p>
                    <p className="text-gray-600">omnisourcetalent@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                    <i className="ri-map-pin-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">地址</p>
                    <p className="text-gray-600">灣仔灣仔道133號卓凌中心11樓</p>
                    <p className="text-gray-600 text-sm">11/F, TIMES MEDIA CENTRE, 133 WANCHAI ROAD, WANCHAI, HONG KONG</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                    <i className="ri-time-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">營業時間</p>
                    <p className="text-gray-600">週一至週五 9:00 - 18:00</p>
                    <p className="text-gray-600">週六 9:00 - 13:00</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 快速聯繫按鈕 */}
            <div className="space-y-4">
              <h4 className="text-lg font-semibold text-gray-800">快速聯繫</h4>
              <div className="flex justify-center space-x-4">
                <a
                  href="https://wa.me/85293663961"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600 transition-colors whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  <span>WhatsApp</span>
                </a>
                <a
                  href="tel://+85293663961"
                  className="flex items-center space-x-2 bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors whitespace-nowrap"
                >
                  <i className="ri-phone-line text-xl"></i>
                  <span>立即致電</span>
                </a>
              </div>
            </div>
          </div>

          {/* 諮詢表單 */}
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-800 mb-6">免費諮詢</h3>
            
            {submitMessage && (
              <div className={`mb-6 p-4 rounded-lg ${submitMessage.includes('感謝') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                {submitMessage}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    姓名 *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="請輸入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                    公司名稱
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="請輸入公司名稱"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    聯絡電話 *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="請輸入聯絡電話"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    電郵地址 *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="請輸入電郵地址"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2">
                    所需服務
                  </label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm pr-8"
                  >
                    <option value="">請選擇服務類型</option>
                    <option value="quota-application">外勞配額申請</option>
                    <option value="visa-processing">簽證申請代辦</option>
                    <option value="accommodation">宿舍管理服務</option>
                    <option value="training">專業培訓服務</option>
                    <option value="full-service">一站式服務</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="workers" className="block text-sm font-medium text-gray-700 mb-2">
                    預計外勞人數
                  </label>
                  <input
                    type="text"
                    id="workers"
                    name="workers"
                    value={formData.workers}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="例如：10-20人"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  詳細需求
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm resize-none"
                  placeholder="請詳細描述您的需求，我們將為您提供最適合的解決方案..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">最多500字</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-green-600 text-white py-4 px-6 rounded-lg hover:bg-green-700 transition-colors font-semibold text-lg disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSubmitting ? '提交中...' : '提交諮詢'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
